import * as Yup from 'yup';
import { StockLotQuerySchema } from 'types/inventory';

interface KitRequestLineFormValues {
  stockLot: Pick<
    StockLotQuerySchema,
    | 'quant'
    | 'id'
    | 'part'
    | 'dimensionValue'
    | 'dimensionClass'
    | 'dimensionUnit'
  >;
  targetQuantity: number;
}

export const createKitRequestLineFormConstants = {
  part: { label: 'Part', id: 'part' },
  v2OrgPart: { label: 'Part', id: 'v2OrgPart' },
  targetQuantityPart: { label: 'Quantity', id: 'targetQuantityPart' },
  targetQuantityStockLot: { label: 'Quantity', id: 'targetQuantityStockLot' },
  stockLot: { label: 'Stock Lot', id: 'stockLot' },
  targetDimensionValuePart: {
    label: 'Quantity',
    id: 'targetDimensionValuePart',
  },
  targetDimensionValueStockLot: {
    label: 'Quantity',
    id: 'targetDimensionValueStockLot',
  },
  dimensionUnitPart: { label: 'Unit', id: 'dimensionUnitPart' },
  dimensionUnitStockLot: { label: 'Unit', id: 'dimensionUnitStockLot' },
  dimensionClassPart: { label: 'Dimension Class', id: 'dimensionClassPart' },
  dimensionClassStockLot: {
    label: 'Dimension Class',
    id: 'dimensionClassStockLot',
  },
};

function validateQuantity(
  this: { parent: KitRequestLineFormValues },
  value: number | undefined
) {
  const { stockLot } = this.parent;
  return Boolean(value && value <= stockLot?.quant);
}

export function validateDimensionValue(
  this: { parent: KitRequestLineFormValues },
  value: number | undefined
) {
  const { stockLot } = this.parent;
  return Boolean(value && value <= stockLot?.dimensionValue);
}

export const updateKitRequestLineQuantOnly = {
  [createKitRequestLineFormConstants.targetQuantityStockLot.id]: Yup.number()
    .required(
      `${createKitRequestLineFormConstants.targetQuantityStockLot.label} is required`
    )
    .typeError(
      `${createKitRequestLineFormConstants.targetQuantityStockLot.label} is required`
    ),
};

export const createKitRequestLineStockLotValidation = (tempUoM: boolean) => ({
  [createKitRequestLineFormConstants.stockLot.id]: Yup.object()
    .required('Stock Lot is required')
    .typeError('Stock Lot is required'),
  ...(tempUoM
    ? {
        [createKitRequestLineFormConstants.targetDimensionValueStockLot.id]:
          Yup.number()
            .required('Quantity is required')
            .typeError('Quantity is required')
            .test(
              'is-valid-quantity',
              'Target Quantity must be less than or equal to the available stock lot quantity',
              validateDimensionValue
            ),
        [createKitRequestLineFormConstants.dimensionUnitStockLot.id]:
          Yup.string()
            .required('Unit is required')
            .typeError('Unit is required'),
        [createKitRequestLineFormConstants.dimensionClassStockLot.id]:
          Yup.string()
            .required('Dimension class is required')
            .typeError('Dimension class is required'),
      }
    : {
        [createKitRequestLineFormConstants.targetQuantityStockLot.id]:
          Yup.number()
            .required(
              `${createKitRequestLineFormConstants.targetQuantityStockLot.label} is required`
            )
            .typeError(
              `${createKitRequestLineFormConstants.targetQuantityStockLot.label} is required`
            )
            .test(
              'is-valid-quantity',
              'Target Quantity must be less than or equal to the available stock lot quantity',
              validateQuantity
            ),
      }),
});

export const createKitRequestLinePartValidation = (tempUoM: boolean) => ({
  [createKitRequestLineFormConstants.v2OrgPart.id]:
    Yup.string().required('Part is required'),
  ...(tempUoM
    ? {
        [createKitRequestLineFormConstants.targetDimensionValuePart.id]:
          Yup.number()
            .required('Quantity is required')
            .typeError('Quantity is required'),
        [createKitRequestLineFormConstants.dimensionUnitPart.id]: Yup.string()
          .required('Unit is required')
          .typeError('Unit is required'),
        [createKitRequestLineFormConstants.dimensionClassPart.id]: Yup.string()
          .required('Dimension class is required')
          .typeError('Dimension class is required'),
      }
    : {
        [createKitRequestLineFormConstants.targetQuantityPart.id]: Yup.number()
          .required(
            `${createKitRequestLineFormConstants.targetQuantityPart.label} is required`
          )
          .typeError(
            `${createKitRequestLineFormConstants.targetQuantityPart.label} is required`
          ),
      }),
});
